var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBills(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9463 6.38218L34.9661 4.13721C34.9848 2.02119 33.8207 0.296267 32.3636 0.283385L32.0011 0.28018C30.5454 0.267311 28.1421 1.9607 28.1234 4.07671L27.1205 4.06785L16.637 3.97517L16.4497 25.1661L33.1411 25.3137C34.0453 25.3217 34.7841 24.5676 34.7924 23.6283L34.9449 6.38217L34.9463 6.38218Z",
    fill: "#DADADA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6584 27.8685L0.185547 13.7113L31.4849 13.988L15.6584 27.8685Z",
    fill: "#CBA876"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4848 13.9883L15.9334 2.81267L0.185384 13.7116L31.4848 13.9883Z",
    fill: "#CBA876"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2595 0.282535L6.625 0.0559127C4.58812 0.0379056 2.92259 1.73782 2.90388 3.85383L2.70102 26.8003L2.64112 33.5762L28.2756 33.8029L28.3355 27.0269L28.5384 4.08045C28.5571 1.96444 30.2226 0.264528 32.2595 0.282535Z",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89893 14.2061L24.5312 14.3619",
    stroke: "#D9D9D9",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87573 16.8367L24.508 16.9925",
    stroke: "#D9D9D9",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85254 19.4671L24.4848 19.623",
    stroke: "#D9D9D9",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8291 22.0986L24.4614 22.2545",
    stroke: "#D9D9D9",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M2.79275 16.3612L8.27082 19.6718C12.7863 22.4009 18.3319 22.5408 22.974 20.0465L28.4226 17.1183L28.416 17.8583L15.4767 31.631L2.74435 16.8898L2.79275 16.3612Z",
    fill: "#7C8787"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7165 27.1964L0.185547 13.7113L0.000941702 34.593L31.3003 34.8697L31.4849 13.988L15.7165 27.1964Z",
    fill: "#E0B88B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2993 34.9685L15.77 21.2841L-0.000124772 34.6918L31.2993 34.9685Z",
    fill: "#E9C092"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M30.1906 34.9603L27.5368 33.3907C20.1299 29.0108 11.2729 28.9325 3.78968 33.1808L1.10861 34.7032L30.1906 34.9603Z",
    fill: "#EDBD8A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0467 3.41749L0.685791 3.18445L0.611625 11.5738L26.9726 11.8068L27.0467 3.41749Z",
    fill: "#E96666"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9504 13.3413L0.611572 11.5752L2.96583 11.596L2.9504 13.3413Z",
    fill: "#C23240"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0769 9.1361L8.11428 4.90784L9.59534 4.92093C10.1084 4.92547 10.4966 5.02764 10.7601 5.22746C11.0236 5.42534 11.1537 5.71402 11.1504 6.09347C11.1485 6.30063 11.0937 6.48311 10.9858 6.64092C10.8779 6.7968 10.7288 6.91068 10.5384 6.98258C10.7548 7.0387 10.9242 7.14959 11.0466 7.31525C11.171 7.48092 11.2322 7.68283 11.2301 7.92096C11.2265 8.32752 11.094 8.6342 10.8327 8.841C10.5715 9.04779 10.2008 9.151 9.72058 9.15063L8.0769 9.1361ZM8.96439 7.30265L8.9543 8.44393L9.70063 8.45053C9.90585 8.45234 10.066 8.40536 10.1811 8.30957C10.2981 8.21185 10.3574 8.07685 10.3589 7.90454C10.3623 7.51734 10.1637 7.31906 9.763 7.30971L8.96439 7.30265ZM8.96983 6.687L9.61453 6.6927C10.0541 6.68884 10.2754 6.51557 10.2784 6.17289C10.2801 5.98123 10.2252 5.84327 10.1136 5.75903C10.004 5.67287 9.82917 5.62873 9.5891 5.62661L8.97925 5.62122L8.96983 6.687Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9504 9.17919L12.0792 9.17148L12.1166 4.94322L12.9878 4.95092L12.9504 9.17919Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7867 8.49549L16.6366 8.51185L16.6304 9.21172L13.9094 9.18766L13.9467 4.9594L14.8179 4.9671L14.7867 8.49549Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1589 8.52531L20.0088 8.54166L20.0026 9.24153L17.2815 9.21747L17.3189 4.98921L18.1901 4.99691L18.1589 8.52531Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBills);
export default __webpack_public_path__ + "static/media/bills.f6c49c0b43ae4314ec37c7fe28e22945.svg";
export { ForwardRef as ReactComponent };